import { tw } from 'utils/classnames'

export function Card({
  className = '',
  children,
}: {
  className?: string
  children?: React.ReactNode
}) {
  return (
    <div className={tw('rounded-2 bg-cf-white @container border border-[#DADCE2] p-6', className)}>
      {children}
    </div>
  )
}

export function CardInner({
  className = '',
  children,
}: {
  className?: string
  children?: React.ReactNode
}) {
  return <Card className={tw('@lg:p-6 p-3', className)}>{children}</Card>
}

export function CardSkeleton() {
  return (
    <Card>
      <div className="flex flex-col gap-8">
        <div className="bg-cf-black/5 rounded-2 h-12 w-1/3 animate-pulse" />
        <div className="flex flex-col gap-4">
          <div className="bg-cf-black/5 rounded-2 h-10 animate-pulse" />
          <div className="bg-cf-black/5 rounded-2 h-10 animate-pulse" />
          <div className="bg-cf-black/5 rounded-2 h-10 animate-pulse" />
        </div>
      </div>
    </Card>
  )
}

export function CardSkeletonInner() {
  return (
    <Card className="border-0 p-0">
      <div className="flex flex-col gap-8">
        <div className="bg-cf-black/5 rounded-2 h-12 w-1/3 animate-pulse" />
        <div className="flex flex-col gap-4">
          <div className="bg-cf-black/5 rounded-2 h-10 animate-pulse" />
          <div className="bg-cf-black/5 rounded-2 h-10 animate-pulse" />
          <div className="bg-cf-black/5 rounded-2 h-10 animate-pulse" />
        </div>
      </div>
    </Card>
  )
}
